import Shake from 'shake.js';
import keyboard from './keyboard';
import TransparentPlayer from './transparent-player';
import router from './router';
import loader from './loader';

let $html = $(document.documentElement);

function checkDevices() {
	if (innerWidth > 1024) {
		if ($html.hasClass('is-device-mobile')) {
			$html.removeClass('is-device-mobile').addClass('is-device-desktop');
		}
	}
}

checkDevices();

let $shareOpened;
let $popupOpened;
let scrollBarActive = false;
let $currentContent;
let complete = 0;
let isDeviceMobile = $html.hasClass('is-device-mobile') || $html.hasClass('is-device-tablet');

function $getPage(id) {
	return $(`#timeline-${id}`);
}

function exists(id) {
	return !!$getPage(id).length;
}

function openPopup($popup) {
	let $page = $popup.closest('.page');
	let playerMain = $page.data('player-main');

	if (isDeviceMobile) {
		$currentContent = $popup.find('.timeline__popup__container__content');
	} else {
		$currentContent = $popup.find('.timeline__popup__content');
	}

	if (playerMain && !playerMain.video.paused) {
		playerMain.video.pause();
		playerMain.video.muted = !playerMain.video.muted;
		$page.addClass('is-muted');
		$page.addClass('is-temporarily-paused');
	}

	new TimelineMax({
		onStart() {
			$html.addClass('is-popup-open');

			scrollBarActive = true;

			$currentContent.mCustomScrollbar({
				autoHideScrollbar: false,
			});

			$popup.addClass('is-open');
			$popupOpened = $popup;

			scrollBarActive = true;

			$currentContent.mCustomScrollbar({
				autoHideScrollbar: false,
			});

			if (!isDeviceMobile) {
				let $currentParent = $currentContent.parent().parent();
				let currentBoxHeight = $currentParent.find('.mCustomScrollBox').height();
				let currentContainerHeight = $currentParent.find('.mCSB_container').height();

				if (currentBoxHeight > currentContainerHeight && innerWidth > 1024) {
					$currentParent.addClass('is-relative');
				}
			}

			let id = $popup.attr('id');
			let hash = `#${id}`;

			if (history.pushState) {
				history.pushState(null, null, hash);
			} else {
				window.location.hash = hash;
			}
		},
	})
		.from($popup, 0.7, {
			autoAlpha: 0,
			clearProps: 'all',
		}, 0);

	$(document).trigger('open-popup', [$popup]);
}

function closePopup() {
	if (!$popupOpened) {
		return;
	}

	let $page = $popupOpened.closest('.page');
	let playerMain = $page.data('player-main');

	new TimelineMax({
		onStart() {
			$html.removeClass('is-popup-open');
			history.replaceState(null, null, ' ');
		},
		onComplete() {
			if ($popupOpened) {
				$('.timeline__popup.is-open').removeClass('is-open');
				TweenMax.set([$popupOpened, $('.timeline__popup')], {clearProps: 'all'});
				$popupOpened = null;
			}

			if (playerMain && $page.hasClass('is-temporarily-paused')) {
				playerMain.video.play();
				$page.removeClass('is-muted');
				playerMain.video.muted = !playerMain.video.muted;
				$page.removeClass('is-temporarily-paused');
			}

			scrollBarActive = false;
			$currentContent.mCustomScrollbar('destroy');
		},
	})
		.to($('.timeline__popup'), 0.7, {
			autoAlpha: 0,
		});
}

function openShare($share) {
	$share.addClass('is-open');
	$shareOpened = $share;
}

function closeShare() {
	if (!$shareOpened) {
		return;
	}

	$shareOpened.removeClass('is-open');
	$shareOpened = null;
}

function init($page) {
	let $playerMain = $page.find('.transparent-player--main');
	let $playerLoop = $page.find('.transparent-player--loop');
	let $playerSecret = $page.find('.transparent-player--secret');
	let playerMain;
	let playerLoop;
	let playerSecret;
	let start = false;
	let finish = false;
	let timer = 0;

	function setResetInterval(bool) {
		if (bool) {
			timer = setInterval((name) => {
				name = $page.find('.timeline__navigation__link.is-active').text();

				ga('send', 'event', 'video', 'timing 5s', name, 5);
				ga('rbcspec.send', 'event', 'video', 'timing 5s', '', 5);
			}, 5000);
		} else {
			clearInterval(timer);
		}
	}

	$page.addClass('is-not-started');
	$page.removeClass('is-playing is-paused is-complete');

	if (!$playerMain.length || !$playerLoop.length) {
		return Promise.resolve();
	}

	if ($page.hasClass('is-initialized')) {
		playerMain = $page.data('player-main');
		playerLoop = $page.data('player-loop');
		playerSecret = $page.data('player-secret');

		playerMain.video.currentTime = 0;
		playerLoop.video.currentTime = 0;

		playerMain.startRendering();
		playerLoop.stopRendering();

		if (playerSecret) {
			playerSecret.video.currentTime = 0;
			playerSecret.stopRendering();
		}

		return Promise.resolve();
	}

	$page.addClass('is-initialized');

	playerMain = new TransparentPlayer($playerMain.get(0));
	playerLoop = new TransparentPlayer($playerLoop.get(0));

	$page.data('player-main', playerMain);
	$page.data('player-loop', playerLoop);

	if ($playerSecret.length) {
		playerSecret = new TransparentPlayer($playerSecret.get(0));
		$page.data('player-secret', playerSecret);
	}

	return Promise.all([
		playerMain.init().then(() => {
			let rem = $(playerMain.container).data('loaded-part-size') ?
				+playerMain.container.getAttribute('data-size') - +$(playerMain.container).data('loaded-part-size') :
				playerMain.container.getAttribute('data-size');

			if (!rem) {
				return;
			}

			loader.sizeOfLoadedFiles(rem);
		}),
		playerLoop.init(false).then(() => {
			let rem = $(playerLoop.container).data('loaded-part-size') ?
				+playerLoop.container.getAttribute('data-size') - +$(playerLoop.container).data('loaded-part-size') :
				playerLoop.container.getAttribute('data-size');

			if (!rem) {
				return;
			}

			loader.sizeOfLoadedFiles(rem);
		}),
		(playerSecret ? playerSecret.init(false) : Promise.resolve()).then(() => {
			if (playerSecret) {
				let rem = $(playerSecret.container).data('loaded-part-size') ?
					+playerSecret.container.getAttribute('data-size') - +$(playerSecret.container).data('loaded-part-size') :
					playerSecret.container.getAttribute('data-size');

				if (!rem) {
					return;
				}

				loader.sizeOfLoadedFiles(rem);
			}
		}),
	])
		.then(() => {
			$(playerMain.video)
				.on('play', () => {
					$page.removeClass('is-not-started is-paused');
					$page.addClass('is-playing');
					let name = $page.find('.timeline__navigation__link.is-active').text();

					if (start === false) {
						ga('send', 'event', 'video', 'play', name, {nonInteraction: true});
						ga('rbcspec.send', 'event', 'video', 'play', {nonInteraction: true});
						start = true;
					}

					setResetInterval(true);
				})
				.on('pause', () => {
					$page.removeClass('is-playing');
					$page.addClass('is-paused');

					setResetInterval(false);
				})
				.on('ended', () => {
					$page.removeClass('is-playing');
					$page.addClass('is-complete');

					let name = $page.find('.timeline__navigation__link.is-active').text();

					if (finish === false) {
						ga('send', 'event', 'video', 'finish', name);
						ga('rbcspec.send', 'event', 'video', 'finish');
						finish = true;
					}

					complete++;

					if (complete === 6) {
						ga('send', 'event', 'timeline page', 'all video complete view');
					}

					setResetInterval(false);

					playerLoop.startRendering();

					setTimeout(() => {
						playerMain.stopRendering();
						playerLoop.video.play();
						$page.trigger('main-complete');
					}, 600);
				});

			if (!playerSecret) {
				return;
			}

			$(playerSecret.video)
				.on('play', () => {
					$page.addClass('is-playing-secret');

					playerSecret.startRendering();

					setTimeout(() => {
						playerLoop.video.pause();
						playerLoop.video.currentTime = 0;
						playerLoop.stopRendering();
						playerSecret.video.play();
					}, 600);
				})
				.on('ended', () => {
					$page.removeClass('is-playing-secret');

					playerLoop.startRendering();

					setTimeout(() => {
						playerSecret.video.pause();
						playerSecret.video.currentTime = 0;
						playerSecret.stopRendering();
						playerLoop.video.play();
						$page.trigger('secret-complete');
					}, 600);
				});

			$page.on('play-secret', () => {
				if ($page.prop('hidden') || !$page.hasClass('is-complete') || $page.data('secret-played')) {
					return;
				}

				playerSecret.video.play();
				$page.data('secret-played', true);
			});
		});
}

function reset($page) {
	let playerMain = $page.data('player-main');
	let playerLoop = $page.data('player-loop');
	let playerSecret = $page.data('player-secret');

	if (playerMain) {
		playerMain.video.pause();
		playerMain.video.currentTime = 0;
		playerMain.stopRendering();
	}

	if (playerLoop) {
		playerLoop.video.pause();
		playerLoop.video.currentTime = 0;
		playerLoop.stopRendering();
	}

	if (playerSecret) {
		playerSecret.video.pause();
		playerSecret.video.currentTime = 0;
		playerSecret.stopRendering();
	}

	$page.trigger('page-reset');
	$page.addClass('is-not-started');
	$page.removeClass('is-playing is-paused is-complete is-temporarily-paused is-playing-secret');
	$page.data('secret-played', false);
	clearTimeout($page.data('secret-timeout'));
}

$(window).on('resize', () => {
	if (scrollBarActive) {
		$currentContent.mCustomScrollbar('update');
	}
});

$('.timeline__pin').on('click', (e) => {
	let $pin = $(e.currentTarget);
	let $popup = $(`#${$pin.data('popup-id')}`);

	openPopup($popup);
});

$('.timeline__popup__close').on('click', (e) => {
	let $button = $(e.currentTarget);

	$button.trigger('blur');
	closePopup();
});

$('.timeline__play__button, .timeline__start').on('click', (e) => {
	let $button = $(e.currentTarget);
	let $page = $button.closest('.page');
	let playerMain = $page.data('player-main');

	$button.trigger('blur');

	if (!playerMain) {
		return;
	}

	if ($page.hasClass('is-complete')) {
		if ($page.hasClass('is-last')) {
			router.navigate('/');
		} else {
			let href = $page.find('.timeline__navigation__link.is-active').next().get(0).getAttribute('href');

			router.navigate(href);
		}
	} else if ($page.hasClass('is-not-started') || $page.hasClass('is-paused')) {
		playerMain.video.play();
	} else if ($page.hasClass('is-playing')) {
		playerMain.video.pause();
	}
});

$('.timeline__sound__toggle').on('click', (e) => {
	let $button = $(e.currentTarget);
	let $page = $button.closest('.timeline');
	let playerMain = $page.data('player-main');

	$button.trigger('blur');

	if (!playerMain) {
		return;
	}

	playerMain.video.muted = !playerMain.video.muted;
	$page.toggleClass('is-muted');
});

$('.timeline__footer__arrow').on('click', (e) => {
	let $this = $(e.currentTarget);
	let $footer = $this.closest('.timeline__footer');

	if (!$footer.hasClass('is-open')) {
		$footer.addClass('is-open');
	} else {
		$footer.removeClass('is-open');
	}
});

$('.timeline__share__toggle')
	.on('mouseenter', (e) => {
		let $button = $(e.currentTarget);
		let $share = $button.closest('.timeline__share');

		$button.trigger('blur');
		openShare($share);
	});

$('.timeline__share__popup')
	.on('mouseleave', () => {
		closeShare();
	});

$('.timeline__share').on('click touchstart', (e) => {
	e.stopPropagation();
});

$(document)
	.on('click touchstart', () => {
		closeShare();
	})
	.on('keydown', (e) => {
		if (e.keyCode === keyboard.ESCAPE) {
			closeShare();
			closePopup();
		}
	});

$('#timeline-2000').on('main-complete', (e) => {
	let $page = $(e.currentTarget);

	$page.data('secret-timeout', setTimeout(() => {
		$page.trigger('play-secret');
	}, 2 * 60 * 1000));
});

if (isDeviceMobile) {
	let shake = new Shake({
		threshold: 15,
		timeout: 1000,
	});

	let $page3 = $('#timeline-1980-1990');

	$page3
		.on('main-complete', () => {
			shake.start();
		})
		.on('secret-complete', () => {
			$page3.data('secret-timeout', setTimeout(() => {
				$page3.data('secret-played', false);
			}, 5 * 1000));
		})
		.on('page-reset', () => {
			shake.stop();
		});

	window.addEventListener('shake', () => {
		$page3.trigger('play-secret');
	}, false);
}

export default {
	init,
	reset,
	exists,
	openPopup,
	$getPage,
};
